import React, { Component } from 'react';
import AdmissionApi from '../../Services/AdmissionApi';

import './style.css';
const admissionApi = new AdmissionApi();


class LoginForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user_name: '',
            password: '',
            otp: '',
            id: 'signin-link',
            errors: {},
            check: false
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleLoginClick = this.handleLoginClick.bind(this);
        this.showSelectedId = this.showSelectedId.bind(this);

        this.admissionsService = new AdmissionApi();
    }

    handleChange(evt) {
        if (this.state.check) {
            this.handleValidation();
        }
        this.setState({ [evt.target.name]: evt.target.value });
    }

    updateState = (newResponse) => {
        if (newResponse.data.success) {

            this.setState({ otp: newResponse.data.attributes.user.otp });
            let obj = {
                email: this.state.user_name,
                password: this.state.password,
                destination_mobile_no: newResponse.data.attributes.user.phone,
                otp: newResponse.data.attributes.user.otp,
                type: newResponse.data.attributes.user.type,
                category: false
            };

            let categoryObj = {
                first_name: newResponse.data.attributes.user.first_name,
                last_name: newResponse.data.attributes.user.last_name,
                user_name: newResponse.data.attributes.user.user_name,
                school_code: newResponse.data.attributes.user.school_code,
                gender: newResponse.data.attributes.user.gender,
                date_of_birth: newResponse.data.attributes.user.date_of_birth,
                email: newResponse.data.attributes.user.email
            }

            if (newResponse.data.attributes.user.type == 1 || newResponse.data.attributes.user.type == 2) {
                localStorage.setItem('userType', newResponse.data.attributes.user.type);
                localStorage.setItem('isAdminLogin', true);
            } else {

                localStorage.setItem('userInfo', JSON.stringify(categoryObj));
                localStorage.setItem('userId', newResponse.data.attributes.user.id);
                localStorage.setItem('isLogin', "1");

            }

            this.props.sendData(obj, 'otp-link');

        } else {
            let errors = {};
            if (newResponse.data.isInactive) {
                this.props.sendDataWithOtp({ email: this.state.user_name, isInactive: newResponse.data.isInactive }, 'otp-link');
            } else {
                errors['responseError'] = 'Either email or password is incorrect';
                this.setState({ errors: errors });
            }

        }
    }


    // handleLoginClick = (e) => {
    //     e.preventDefault()
    //     this.setState({ check: true });
    //     if (this.handleValidation()) {
    //         let obj = {
    //             email: this.state.user_name,
    //             password: this.state.password
    //         };
    //         this.admissionsService.createNew(this.updateState, obj, 'v1/users/login');
    //     }
    // }

    handleLoginClick = (e) => {
        e.preventDefault();
        this.setState({ check: true });
        if (this.handleValidation()) {
          const obj = {
            email: this.state.user_name,
            password: this.state.password,
          };
      
          this.admissionsService.createNew((resp) => {
            this.updateState(resp);
      
            const user = resp && resp.data && resp.data.attributes && resp.data.attributes.user
              ? resp.data.attributes.user
              : null;
      
            const lsAdmin = (() => {
              try {
                const v = localStorage.getItem("isAdminLogin");
                return v === "true" || v === "1" || v === "true";
              } catch (err) {
                return false;
              }
            })();
      
            const respAdmin = user ? (user.type === 1 || user.type === 2) : false;
      
            const isAdmin = lsAdmin || respAdmin;

            if (user && user.id) {
              try {
                localStorage.setItem("userId", String(user.id));
              } catch (err) {}
            }

            if (!isAdmin) {
              try {
                localStorage.setItem("isLogin", "1");
              } catch (err) {}
            }

            if (!isAdmin && user && user.id) {
              try {
                admissionApi.createNew(() => {}, { userId: Number(user.id) }, "v1/student-activity/login");
              } catch (e) {
              }
            }
          }, obj, "v1/users/login");
        }
      };
      
      


    showSelectedId(event) {
        this.props.changeForm(event);
    }

    handleValidation() {
        let fields = this.state;
        let errors = {};
        let formIsValid = true;

        //Email
        if (!fields["user_name"]) {
            formIsValid = false;
            errors["user_name"] = "Cannot be empty";
        }

        if (fields['user_name'] && !fields["user_name"].match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
            formIsValid = false;
            errors["user_name"] = "Email is not valid";
        }

        //password
        if (!fields["password"]) {
            formIsValid = false;
            errors["password"] = "Cannot be empty";
        }

        errors['responseError'] = '';

        this.setState({ errors: errors });
        return formIsValid;
    }

    errorsHandling(data) {
        let errors = {};
        Object.keys(data).forEach(function (key, i) {
            errors[key] = data[key][0];
        });

        this.setState({ errors: errors });
    }

    render() {
        const whoIsLogin = window.location.pathname.slice(1).split('/')[0]
        return (
            <div className="g-bg-white rounded">
                <h1>Login</h1>
                <div className={this.state.errors["user_name"] ? null : 'g-mb-10'}>
                    <div className="input-group admn-input-group">
                        <span className="input-group-addon g-width-50 g-brd-secondary-light-v2 g-bg-secondary g-rounded-right-0">
                            <i className="fa fa-envelope"></i>
                        </span>
                        <input className="form-control g-brd-secondary-light-v2 g-bg-secondary g-bg-secondary-dark-v1--focus g-rounded-left-0 g-px-20 g-py-12" type="email" name="user_name" placeholder="E-mail address" onChange={this.handleChange} />

                    </div>
                    <span style={{ color: "red" }}>{this.state.errors["user_name"]}</span>
                </div>

                <div className={(this.state.errors["password"] || this.state.errors["responseError"]) ? null : 'g-mb-10'}>
                    <div className="input-group admn-input-group">
                        <span className="input-group-addon g-width-50 g-brd-secondary-light-v2 g-bg-secondary g-rounded-right-0">
                            <i className="fa fa-lock"></i>
                        </span>
                        <input className="form-control g-brd-secondary-light-v2 g-bg-secondary g-bg-secondary-dark-v1--focus g-rounded-left-0 g-px-20 g-py-12" type="password" name="password" placeholder="Password" onChange={this.handleChange} />
                    </div>
                    <span style={{ color: "red" }}>{this.state.errors["password"]}</span>
                    <span style={{ color: "red" }}>{this.state.errors["responseError"]}</span>
                    {whoIsLogin !== 'admin' && (
                        <button type="button" className='btn btn-link p-0 auth-link forgot-password' id="forgot-password-link" onClick={(event) => this.showSelectedId(event)}>Forgot Password?</button>
                    )}
                </div>

                <div className="d-flex justify-content-between align-items-center py-1 w-100">
                    <button type="submit" id="otp-link" className="admn-btn btn w-100 u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-font-size-default rounded g-px-25 g-py-7" onClick={this.handleLoginClick}>Login</button>
                </div>
                {whoIsLogin !== 'admin' && (
                    <div className='text-center'>Do not have an account? <button type="button" className="btn btn-link auth-link p-0" id="signup-link" onClick={(event) => this.showSelectedId(event)}>Create Account</button></div>
                )}
            </div>
        );
    }
}

export default LoginForm;



/** WEBPACK FOOTER **
 ** ./src/components/SignIn/LoginForm.js
 **/